import React from 'react';
import './Todo.css'; // Aggiornato import CSS

interface WidgetProps {
  onClose: () => void;
  className?: string;
}

const Todo: React.FC<WidgetProps> = ({ onClose, className }) => {
  return (
    <div className={`widget-card todo-widget ${className || ''}`}> {/* Mantengo la classe specifica se serve per CSS */} 
      <div className="widget-header">
        <h3>Todo</h3>
        <button onClick={onClose} className="widget-close-btn" aria-label="Chiudi widget Todo">
          <i className="fas fa-times"></i>
        </button>
      </div>
      <div className="widget-content">
        <p>Elenco delle cose da fare...</p>
        {/* Contenuto specifico del widget Todo qui */}
      </div>
    </div>
  );
};

export default Todo; // Aggiunto export default 